module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.loginForm.name),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "name", $$v)
      },
      expression: "loginForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "pass", $$v)
      },
      expression: "loginForm.pass"
    }
  })], 1), _vm._v(" "), (_vm.isDev) ? _c('el-form-item', {
    attrs: {
      "label": "服务域名"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入服务域名地址",
      "select-when-unmatched": true
    },
    model: {
      value: (_vm.domain),
      callback: function($$v) {
        _vm.domain = $$v
      },
      expression: "domain"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "loginBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.loginSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "captchaBox"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-393195af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 992
// module chunks = 0